import type { TableRowData } from '@/ui/components/TeamsTable/TeamsTable.types';

import type { GroupOverviewTeamRow } from '../types';

export function mapGroupTableTeamsToTableRowData(teams: GroupOverviewTeamRow[]): TableRowData[] {
  return teams.map((team) => {
    const base = {
      position: team.no,
      teamName: team.name,
      playedMatches: team.playedMatches,
      wins: team.wins,
      draws: team.draws,
      losses: team.losses,
      points: team.points,
      isHighlighted: team.isHome || team.isAway,
    };

    return {
      ...base,
      ...(team.jersey ? { jerseySrc: team.jersey } : {}),
    } satisfies TableRowData;
  });
}
